import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as clipboard from 'clipboard-polyfill';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';

import * as styles from '../styles/PublicFacingUrlCopyButtonStyle';

const BROADCAST_SHARE_URL_TEST_ID = 'btn-broadcast-share-url';

interface ShareLinkProps {
	shareLink: string;
	contentName: string;
}

export const PublicFacingUrlCopyButton = (props: ShareLinkProps): JSX.Element => {
	return <ButtonWidget
		buttonType={ButtonType.LowEmphasis}
		style={styles.copyLink}
		onClick={() => handleClickCopyLink(props)}
		testId={BROADCAST_SHARE_URL_TEST_ID}
		getContent={buttonContent}
	/>;
};

const buttonContent = (): JSX.Element => {
	const iconPath = `broadcast_link_icon.svg`;
	return (
		<span className={PageHeaderStyles.TextButton}>
			<img src={imgPath(iconPath)}
				style={PageHeaderStyles.iconForTextButton}
				alt="" />
			{Messages.broadcastCopyPublicFacingUrl()}
		</span>
	);
};

const handleClickCopyLink = (props: ShareLinkProps): void => {
	const text = props.shareLink;
	const successMessage = Messages.broadcastLinkCopiedNotificationText({ CONTENT_NAME: props.contentName });
	copyToClipboard(text, successMessage);
};

export const copyToClipboard = (text: string, successMessage: string) => {
	clipboard.writeText(text);
	ToasterService.instance.pop({ type: ToastType.Success, text: successMessage });
};